import { render, staticRenderFns } from "./RentProtectionLayout.vue?vue&type=template&id=00487738&"
import script from "./RentProtectionLayout.vue?vue&type=script&lang=js&"
export * from "./RentProtectionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports